<template>
    <main>
        <section class="content">
            <DsErrorBannerContainer />

            <RouterView />
        </section>
    </main>
</template>

<script setup>
import { DsErrorBannerContainer } from '@infusionsoft/design-system';
</script>

<style lang="scss" scoped>
.content {
    height: 100vh;
}
</style>
